import axios from 'axios';

export const customerAccountData = async (userToken, customerId) => {
  const query = `
    {
      customer {
        addresses {
          id
          firstname
          lastname
          default_billing
          default_shipping
          street
          city
          region {
            region_code
            region
          }
          postcode
          country_code
          telephone
        }
      }
    }
  `;

  const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://mcstaging.candere.com/graphql',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userToken}`,
    },
    withCredentials: true,
    data: JSON.stringify({ query, variables: {} }),
  };

  try {
    const response = await axios.request(config);
    return response.data;
  } catch (error) {
    console.error("Error fetching customer account data:", error);
    throw error;
  }
};
